import { requiredNullish } from '@breezeventures/web-ph-validators/zod-utils';
import { z } from 'zod';

import { documentSchema } from './document-schema';

export const storePhotosSchema = z.object({
  STORE_AND_MERCHANDISE_DISPLAY: requiredNullish(
    z.array(documentSchema).min(1, 'At least one store photo is required'),
    'At least one store photo is required'
  ),
});

export type StorePhotosFormValues = z.infer<typeof storePhotosSchema>;
